<script lang="ts">
import { defineComponent, ref } from "vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "TarifauswahlElement",
  emits: [],
  props: {
    tarifauswahlInformation: Object,
    anzahlElemente: Number,
  },

  setup(props) {
    const piniaStore = useFormStore();
    const { formatCurrency } = formatUtils();
    const produktLinien = ref(props.anzahlElemente);

    return {
      props,
      piniaStore,
      formatCurrency,
      produktLinien,
    };
  },
});
</script>

<template>
  <div v-if="produktLinien === 3" class="c-form-control-radio o-grid__cell o-grid__cell--4">
    <input
      :id="props.tarifauswahlInformation.produktlinie"
      name="produktLinie"
      type="radio"
      tabindex="0"
      autofocus
      :value="props.tarifauswahlInformation.produktlinie"
      :aria-label="props.tarifauswahlInformation.produktlinie"
      class="gevng-step2-tariffchooser__input c-form-control-radio__input js-tariff-radio1"
      v-model="piniaStore.state.tarifinformationen.produktLinie"
      :data-cy="props.tarifauswahlInformation.produktlinie"
    />
    <label class="c-form-control-radio__label" :for="props.tarifauswahlInformation.produktlinie">
      <span class="base-container active">
        <span class="msg-container">
          <span class="msg">{{ piniaStore.state.isMakler === true ? "" : "Ihre " }}Auswahl</span>
        </span>
        <span class="svg-container">
          <svg
            class="base"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 282.697 265.737"
            width="100%"
            aria-hidden="true"
          >
            <g>
              <polygon
                points="3 215.215 3 3 279.697 3 279.697 215.212 141.63 262.566 3 215.215"
                :fill="props.tarifauswahlInformation.tarifFarbe"
              ></polygon>
              <path
                d="M276.7,6V213.069L141.628,259.4,6,213.069V6H276.7m6-6H0V217.36l4.061,1.387,135.627,46.326,1.944.664,1.942-.667,135.07-46.325,4.053-1.39V0Z"
                fill=""
              ></path>
            </g>
          </svg>
          <svg
            class="rect"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 282.697 265.737"
            width="100%"
            aria-hidden="true"
          >
            <g>
              <rect
                x="3"
                y="3"
                width="276.697"
                height="213.069"
                :fill="props.tarifauswahlInformation.tarifFarbe"
              ></rect>
              <path d="M276.7,6V213.069H6V6H276.7m6-6H0V219.069H282.7V0Z" fill=""></path>
            </g>
          </svg>
        </span>
      </span>
      <span aria-hidden="true" class="c-form-control-radio__icon"></span>
      <span class="c-form-control-radio__label-text">
        <span class="payOnCheckout">
          <span class="tarifauswahl_produktlinie__zusatztext" v-if="!piniaStore.state.isMakler">{{
            props.tarifauswahlInformation.tarifBeschreibung
          }}</span
          ><br />{{ piniaStore.state.preise.produktLinien[props.tarifauswahlInformation.tarifNummer].nameProduktLinie }}
          <br />
          {{
            formatCurrency(
              piniaStore.state.preise.produktLinien[props.tarifauswahlInformation.tarifNummer].gemZahlungsweise,
            )
          }}
        </span>
      </span>
    </label>
  </div>
  <div v-else-if="produktLinien === 2" class="c-form-control-radio o-grid__cell twoCols o-grid__cell--4">
    <input
      :id="props.tarifauswahlInformation.produktlinie"
      name="produktLinie"
      type="radio"
      :value="props.tarifauswahlInformation.produktlinie"
      :aria-label="props.tarifauswahlInformation.produktlinie"
      class="gevng-step2-tariffchooser__input c-form-control-radio__input js-tariff-radio1"
      v-model="piniaStore.state.tarifinformationen.produktLinie"
      :data-cy="props.tarifauswahlInformation.produktlinie"
    />
    <label class="c-form-control-radio__label" :for="props.tarifauswahlInformation.produktlinie">
      <span class="base-container active">
        <span class="msg-container">
          <span class="msg">{{ piniaStore.state.isMakler ? "" : "Ihre " }}Auswahl</span>
        </span>
        <span class="svg-container">
          <svg class="base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 160" width="100%" aria-hidden="true">
            <g>
              <polygon
                points="1.9,129.5 1.9,1.7 278.1,1.7 278.1,129.5 140,158.2"
                :fill="props.tarifauswahlInformation.tarifFarbe"
              ></polygon>
              <path
                d="M276.1,3.5v124.5L140,156.5L3.9,128.1V3.5H276.1 M280,0H0v130.9L140,160l140-29.1V0L280,0z"
                fill=""
              ></path>
            </g>
          </svg>
          <svg aria-hidden="true" class="rect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 131" width="100%">
            <g>
              <rect
                x="3"
                y="3"
                width="276.697"
                height="213.069"
                :fill="props.tarifauswahlInformation.tarifFarbe"
              ></rect>
              <path d="M276.7,6V213.069H6V6H276.7m6-6H0V219.069H282.7V0Z" fill=""></path>
            </g>
          </svg>
        </span>
      </span>
      <span aria-hidden="true" class="c-form-control-radio__icon"></span>
      <span class="c-form-control-radio__label-text">
        <span class="payOnCheckout">
          <span class="tarifauswahl_produktlinie__zusatztext" v-if="!piniaStore.state.isMakler">{{
            props.tarifauswahlInformation.tarifBeschreibung
          }}</span
          ><br />{{ piniaStore.state.preise.produktLinien[props.tarifauswahlInformation.tarifNummer].nameProduktLinie }}
          <br />
          {{
            formatCurrency(
              piniaStore.state.preise.produktLinien[props.tarifauswahlInformation.tarifNummer].gemZahlungsweise,
            )
          }}
        </span>
      </span>
    </label>
  </div>
</template>

<style scoped></style>
